"use strict";
module.exports = require('./en');



//////////////////
// WEBPACK FOOTER
// ./~/date-names/index.js
// module id = 770
// module chunks = 0